export function hydrateFromJson<T>(
  constr: { new (...args: any[]): T },
  data: string,
  strictMode: boolean = true,
  ...args: any[]
): T {
  const obj = JSON.parse(data);
  return hydrateFromObject<T>(constr, obj, strictMode, ...args);
}

export function hydrateFromObject<T>(
  constr: { new (...args: any[]): T },
  obj: any,
  strictMode: boolean = true,
  ...args: any[]
): T {
  const instance = new constr(...args) as any;

  for (const key in obj) {
    if (!strictMode || Object.hasOwn(instance, key)) {
      instance[key] = obj[key];
    }
  }

  return instance;
}
